import Vue from 'vue';

export default class ABaseComponent extends Vue
{
    // Used to check in front-end
    public initialized: boolean = true;

    public loading: boolean = true;
    public error: string = null;


    setLoading(): void {
        this.loading = true;
        this.error = '';
    }

    setLoaded(): void {
        this.loading = false;
        this.error = '';
    }
    setError(error: string): void {
        this.error = error;
        this.loading = false;
    }
    clearError(): void {
        this.error = null;
    }
    getBooleanValue(input: string) : boolean {
        if (input === "True") 
            return true;
        
        return false;
    }

    getTableRowIdentifier(index: number){
        const idenitfier = index % 2 == 0 ? 'even' : 'odd';

        return `tr-index-${index} ${idenitfier}`;
    }
}